<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/danju.png" class="jxyd-imgicon" />
				操作商品调拨单
			</div>
			<button class="jxyd-button jxyd-primary" title="审核" @click="dataSubmitAndCheck"
				v-show="permission.isAudit && documentItem.checkState == 1">
				<Icon type="md-checkbox-outline" size='18' />
				审核
			</button>
			<button class="jxyd-button" title="回滚" @click="rollback([documentItem.id])"
				v-show="permission.isRollback && documentItem.id > 0 && documentItem.checkState > 1">
				<Icon type="md-sync" size='18' />
				回滚
			</button>
			<button class="jxyd-button" title="保存" @click="dataSubmit"
				v-show="permission.isEdit && documentItem.checkState == 1">
				<Icon type="md-bookmark" size='18' />
				保存
			</button>
			<button class="jxyd-button" title="打印" @click="printList" v-show="permission.isPrint">
				<Icon type="md-print" size='18' />
				打印
			</button>
		</div>
		<div>
			<div class="baseInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon" />
						基本信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>

				<table class="baseinfo-table">
					<tr>
						<td class="key">
							单据编号
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input readonly="readonly" v-model="documentItem.code" type="text" placeholder="请输入单据编号"
								class="baseinfo-input" />
						</td>
						<td class="key">
							业务日期
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input v-model="documentItem.businessDate" type="date" placeholder="请选择业务日期"
								class="baseinfo-input" />
						</td>
					</tr>

					<tr>
						<td class="key">
							出库仓库
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" v-model="documentItem.outbound" @on-change='outBoundChange' filterable
								clearable>
								<Option v-for="item in depotList" :value="item.id" :key="item.id">
									{{ item.depotName }}
								</Option>
							</Select>
						</td>
						<td class="key">
							入库仓库
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Cascader size='small' :data="depotTree" v-model="documentItem.warehousing" filterable
								clearable />
						</td>
					</tr>
					<tr>
						<td class="key">
							业务员
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" v-model="documentItem.userId" filterable clearable>
								<Option v-for="item in userList" placeholder="请选择业务员" :value="item.id" :key="item.id">
									{{item.userDisplayName}}
								</Option>
							</Select>
						</td>
						<td class="key">
							备注
						</td>
						<td style="text-align: left;">
							<input type="textarea" v-model="documentItem.note" placeholder="请输入备注"
								class="baseinfo-input">
						</td>
					</tr>
				</table>
			</div>
			<div class="commodityInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
						商品信息
					</div>
					<div class="layout-title-right">
						<SelectCommodityModal ref="selectCommodityModal"
							@getResult="data=>{this.commoditySelected = data;}" :selectedCommodity="commoditySelected"
							:type='"2"'></SelectCommodityModal>
						<SelectCommodityByCodeModal ref="selectCommodityByCodeModal"
							:commoditySelected="commoditySelected"
							@submitSelected='data=>{this.commoditySelected = data;}' @onInputVal='onInputVal'
							:type='"2"'>
						</SelectCommodityByCodeModal>
					</div>
				</div>
				<Table stripe :columns="commodityColumn" :data="documentItem.commodityAllocationDetailList"></Table>
			</div>
			<div class="file">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<Icon type="ios-link" size='20' color='#bd10e0' />
						单据附件
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<DocumentFile :isShow='false' :fileList.sync='documentItem.fileList'
						:actionPath='"/file/file/UploadFile"'></DocumentFile>
				</div>
			</div>
			<div class="billStateCls" v-show="documentItem.checkState == 2"><span>已审核</span></div>
			<div class="billStateCls" v-show="documentItem.checkState == 3"><span>已完结</span></div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import SelectCommodityModal from '@/components/SelectCommodityModal'
	import SelectCommodityPackageModal from '@/components/SelectCommodityPackageModal'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import DocumentFile from '@/components/DocumentFile'
	import SelectCommodityByCodeModal from '@/components/SelectCommodityByCodeModal'
	export default {
		name: 'commodityallocationlistfunc',
		components: {
			SelectCommodityModal,
			DocumentFile,
			SelectCommodityByCodeModal
		},
		computed: {
			commoditySelected: {
				get() {
					let data = [];
					this.documentItem.commodityAllocationDetailList.forEach(item => {
						let formatItems = item.format.split(',');
						let priceTypeData = {};
						let imgFiles = null;
						if (formatItems.length > 1) {
							let priceTypeGroup = item.commodity.commodityPriceTypeGroups.find(m => m
								.groupName == formatItems[0]);
							if (priceTypeGroup) {
								imgFiles = priceTypeGroup.imgFiles;
							}
							priceTypeData = priceTypeGroup.commodityPriceTypes.find(m => m.priceType ==
								formatItems[1]);
						}
						let existData = data.find(m => m.commodity.id == item.commodity.id);
						let isExist = true;
						if (existData) {
							for (let i = 0; i < existData.data.length; i++) {
								if (existData.data[i].unit != item.unit) {
									isExist = false;
									break;
								}
								if (existData.data[i].priceType == item.format) {
									isExist = false;
									break;
								}
							}
						}
						if (existData && isExist) {
							existData.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								unit: item.unit,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
						} else {

							let dataItem = {};
							dataItem.commodity = item.commodity;

							dataItem.data = [];
							dataItem.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								unit: item.unit,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
							data.push(dataItem);
						}
					});
					return data;
				},
				set(newValue) {
					//这的data就是B页面传递过来的数据
					this.documentItem.commodityAllocationDetailList = [];
					newValue.forEach(item => {
						item.data.forEach(item2 => {
							this.documentItem.commodityAllocationDetailList.push({
								commodityId: item.commodity.id,
								name: item.commodity.name,
								unit: item2.unit,
								format: item2.priceType,
								quantity: item2.quantity,
								batchCode: this.getLatestBatchCode(item, item2, this
									.documentItem.outbound),
								outbound: this.getavailableDepot(item2.priceType, this
									.documentItem.outbound, item),
								price: item2.retailPrice,
								discount: 100,
								priceAfterDiscount: item2.retailPrice,
								amount: formatNum(item2.quantity * item2
									.retailPrice),
								note: '',
								creator: parseInt(localStorage.getItem("userId")),
								commodity: item.commodity,
								commodityId: item.commodity.id
							})
						});
					});
				}
			}
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					outbound: '',
					outboundName: '',
					warehousing: [],
					commodityAllocationDetailList: [],
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					checkState: 1, //未审核
					fileList: []
				},
				depotTree: [],
				commodityColumn: [{
						title: '操作',
						key: 'action',
						width: 80,
						align: 'center',
						fixed: 'left',
						render: (h, params) => {
							return [h('Icon', {
								style: {
									cursor: 'pointer'
								},
								props: {
									type: 'md-trash',
									size: 24
								},
								on: {
									click: (e) => {
										this.documentItem.commodityAllocationDetailList.splice(
											params.index, 1);
									}
								}
							})]
						}
					},
					{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 300,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
										});
									}
								}
							}, params.row.name);
						}
					},
					{
						title: '计量单位',
						key: 'unit',
						width: 100,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.unit
									},
									on: {
										input: (event) => {
											this.documentItem.commodityAllocationDetailList[params
													.index].unit =
												event;
										}
									},
								},
								params.row.commodity.extraUnits.map(function(type) {
									if (type != null) {
										return h('Option', {
											props: {
												value: type.unit,
												key: type.unit
											}
										}, type.unit);
									}
								})
							)];
						}
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.quantity,
									'max': this.getSelectedCommodityTypeMaxStock(params.index)
								},
								on: {
									input: (e) => {
										this.documentItem.commodityAllocationDetailList[params
												.index].quantity =
											e;
									}
								}
							})]
						}
					},
					{
						title: '批次号',
						key: 'batchCode',
						width: 200,
						render: (h, params) => {
							return [h('Select', {
									props: {
										disabled: !params.row.commodity.enableBatch,
										multiple: true,
										transfer: true,
										value: params.row.batchCode
									},
									on: {
										input: (event) => {}
									},
								},
								this.formatBatchCodeSelectData(params.index,params.row.unit).map(function(type) {
									return h('Option', {
										props: {
											value: type.value,
											key: type.text
										}
									}, type.text);
								})
							)];
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 200,
					},
					{
						title: '出库仓库',
						key: 'outbound',
						width: 200,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.outbound
									},
									on: {
										input: (event) => {
											this.documentItem.commodityAllocationDetailList[params
												.index].outbound = event;
											let depot = this.depotList.find(m => m.id == val);
											if (depot) {
												this.documentItem.commodityAllocationDetailList[params
													.index].outboundName = depot.depotName;
											}
										}
									},
								},
								this.depotList.map(function(type) {
									return h('Option', {
										props: {
											value: type.id,
											key: type.depotName
										}
									}, type.depotName);
								})
							)];
						}
					},
					{
						title: '单价',
						key: 'price',
						width: 130,
						render: (h, params) => {
							return h('span', {}, this.getCommodityTypePrice(params.row))
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock(params.index))
						}
					},
					{
						title: '备注',
						key: 'note',
						width: 400,
						render: (h, params) => {
							return [h('Input', {
								props: {
									min: 0,
									value: params.row.note
								},
								style: {
									'width': '100%'
								},
								on: {
									input: (e) => {
										this.documentItem.commodityAllocationDetailList[params
											.index].note = e;
									}
								}
							})]
						}
					}
				],
				userList: [],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				},
				depotList: []
			}
		},

		methods: {
			emptyForm() {
				this.documentItem.id = 0
				//this.documentItem.code = ''
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd')
				this.documentItem.outbound = '';
				this.documentItem.outboundName = '';
				this.documentItem.warehousing = [];
				this.documentItem.commodityAllocationDetailList = []
				this.documentItem.userId = parseInt(localStorage.getItem("userId"));
				this.documentItem.userName = localStorage.getItem("userName")
				this.documentItem.creator = parseInt(localStorage.getItem("userId"));
				this.documentItem.note = ''
				this.documentItem.checkState = 1 //未审核
				this.documentItem.fileList = []
				this.getNextCode();
			},
			getCurrentIStock(index) {
				let commodityInventorys = this.documentItem.commodityAllocationDetailList[index].commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.documentItem.commodityAllocationDetailList[index]
						.format &&
						commodityInventorys[i].depotId == this.documentItem.commodityAllocationDetailList[index].outbound
						) {
						stock += commodityInventorys[i].stock;
					}
				}
				let extraUnits = this.documentItem.commodityAllocationDetailList[index].commodity.extraUnits;
				if (extraUnits) {
					extraUnits.forEach(item => {
						if (item.unit == this.documentItem.commodityAllocationDetailList[index].unit) {
							stock = item.conversionRate * stock;
						}
					});
				}
				if (stock && Number.isFinite(stock)) {
					return formatNum(stock);
				} else {
					return 0;
				}
			},
			getCommodityTypePrice(data) {
				const currentUnit = data.commodity.extraUnits.find(m => m.unit == data.unit);
				// 解析价格类型
				const priceTypeItems = data.format.split(',');
				let currentPriceType = null;

				if (priceTypeItems.length === 2) {
					currentPriceType = this.findPriceType(data.commodity, priceTypeItems);
				}
				if (currentUnit && currentPriceType) {
					let price = currentPriceType.retailPrice;
					return formatNum(price / currentUnit.conversionRate);
				}
				return 0;
			},
			// 提取价格类型查找逻辑
			findPriceType(commodity, priceTypeItems) {
				const [groupName, priceTypeName] = priceTypeItems;

				const targetGroup = commodity.commodityPriceTypeGroups.find(
					group => group.groupName === groupName
				);

				if (!targetGroup) return null;

				return targetGroup.commodityPriceTypes.find(
					priceType => priceType.priceType === priceTypeName
				) || null;
			},
			getavailableDepot(priceType, depotId, data) {
				if (!depotId) {
					return 0;
				}
				let availableDepots = data.commodity.commodityInventorys.filter(m => m.depotId == depotId && m.stock > 0);
				if (availableDepots.length > 0) {
					return depotId;
				}
				return 0;
			},
			getSelectedCommodityTypeMaxStock(index) {
				const currentDetail = this.documentItem.commodityAllocationDetailList[index];
				const {
					commodity,
					format,
					outbound,
					unit
				} = currentDetail;

				// 1. 基础检查
				if (!commodity || !commodity.commodityInventorys) return 0;

				// 2. 计算总库存（基础单位）
				const matchedInventories = commodity.commodityInventorys.filter(
					inventory => inventory.commodityPriceType === format &&
					inventory.depotId === outbound
				);

				let baseUnitStock = matchedInventories.reduce((sum, item) => sum + (item.stock || 0), 0);

				// 3. 减去同商品、同规格、同仓库的已选数量（排除自己）
				this.documentItem.commodityAllocationDetailList.forEach((detail, i) => {
					if (i !== index &&
						detail.commodity.id === commodity.id && // 关键：比较商品ID
						detail.format === format &&
						detail.outbound === outbound) {

						const unitData = detail.commodity.extraUnits.find(u => u.unit === detail.unit);
						if (unitData) {
							// 将已选数量转换为基础单位
							baseUnitStock -= detail.quantity / unitData.conversionRate;
						}
					}
				});

				// 4. 将库存转换为当前选择的单位
				const currentUnitData = commodity.extraUnits.find(u => u.unit === unit);
				if (currentUnitData) {
					baseUnitStock = baseUnitStock * currentUnitData.conversionRate;
				}

				// 5. 确保库存不为负数
				//const finalStock = Math.max(baseUnitStock, 0);

				return Number.isFinite(baseUnitStock) ? formatNum(baseUnitStock) : 0;
			},
			getUnitData(item,unit) {
				if (item.commodity.extraUnits) {
					let unitData = item.commodity.extraUnits.find(m => m.unit == unit);
					if (unitData) {
						return unitData;
					}
				}
				return null;
			},
			getLatestBatchCode(item1, item2, depotId) {
				if (item1.commodity.enableBatch != true) {
					return null;
				}
				if (!item1.commodity.commodityInventorys || item1.commodity.commodityInventorys.length <= 0) {
					return null;
				}					
				let codes = [];
				let totalStock = 0;
				let unitData = this.getUnitData(item1,item2.unit);
				if(unitData){
					let latestCode = item1.commodity.commodityInventorys.filter(m => m.stock >
						0 && m
						.commodityPriceType == item2.priceType);
					if (depotId) {
						latestCode = latestCode.filter(m => m.depotId == depotId);
					}
					latestCode = latestCode.sort((a, b) => new Date(a.sellByDate[1]) - new Date(b.sellByDate[1]));
					for (let i = 0; i < latestCode.length; i++) {
						totalStock += formatNum(latestCode[i].stock * unitData.conversionRate);
						codes.push(latestCode[i].batchCode);
						if (totalStock > item2.quantity) {
							break;
						}
					}
				}
				return codes;
			},
			onInputVal(val) {
				this.$refs.selectCommodityModal.searchItems.name = val;
				this.$refs.selectCommodityModal.openSelectCommodityModal();
			},
			submitValidate() {
				if (!this.documentItem.code) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "编号不可为空"
					});
					return false;
				}
				if (!this.documentItem.businessDate) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务日期"
					});
					return false;
				} else {}
				if (!this.documentItem.userId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务员"
					});
					return false;
				}
				if (this.documentItem.commodityAllocationDetailList.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "您还没有选择商品"
					});
					return false;
				}
				if (!this.documentItem.warehousing || this.documentItem.warehousing.length <= 1) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择入库仓库"
					});
					return false
				}

				if (Array.isArray(this.documentItem.warehousing)) {
					this.documentItem.warehousing = this.documentItem.warehousing[1];
				}

				if (!this.documentItem.outbound) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择出库仓库"
					});
					return false
				}
				for (let i = 0; i < this.documentItem.commodityAllocationDetailList.length; i++) {
					if (!this.documentItem.commodityAllocationDetailList[i].outbound) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "请选择商品" + this.documentItem.commodityAllocationDetailList[i]
								.commodityName + "的出库仓库"
						});
						return false
					}
				}
				return true;
			},
			dataSubmit() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/CommodityAllocationList/EditCommodityAllocationList', self.documentItem).then(function(
					response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}
					//记录商品调拨单操作
					var log = {
						FlowId: response.data,
						Title: '商品调拨单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此商品调拨单' : '创建了此商品调拨单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})
					//清空form规则检查
					self.emptyForm();
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});
				}).catch(function(error) {})
			},
			outBoundChange(val) {
				let depot = this.depotList.find(m => m.id == val);
				if (depot) {
					this.documentItem.outboundName = depot.depotName;
				}
			},
			dataSubmitAndCheck() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				let path = '';
				if (self.documentItem.id) {
					path = '/api/CommodityAllocationList/EditCommodityAllocationList';
				} else {
					path = '/api/CommodityAllocationList/AddCommodityAllocationList';
				}
				request.post(path, self.documentItem).then(function(
					response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录商品调拨单操作
					var log = {
						FlowId: self.documentItem.id ? response.data : response.data.id,
						Title: '商品调拨单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此商品调拨单' : '创建了此商品调拨单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})

					if (!self.documentItem.id) {
						self.documentItem = response.data;
					} else {
						self.documentItem.id = response.data;
					}
					self.checkCommodityAllocationList([self.documentItem], 2, '商品调拨单审核后不可更改，内容不可编辑，是否继续操作？');
				}).catch(function(error) {})
			},
			getNextCode() {
				let self = this;
				request.get('/api/CommodityAllocationList/GetNextCode', {
					params: {
						prefix: 'DBD'
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.documentItem.code = response.data;
				}).catch(function(error) {})
			},
			rollback(ids) {
				if (ids.length < 1) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: '是否回滚到审核流程？',
					onOk() {
						request.post('/api/CommodityAllocationList/Rollback', ids).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "商品调拨单回滚失败：" + response.errorMsg
								});
								return;
							}

							var log = [];
							for (var i = 0; i < ids.length; i++) {
								//记录采购单操作
								log.push({
									FlowId: ids[i],
									Title: '商品调拨单日志',
									OperationContent: '回滚了此商品调拨单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '回滚成功!'
							});
							self.getAllocationList(ids[0]);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			checkCommodityAllocationList(objs, state, func) {
				var self = this;
				if (objs.length <= 0) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}

				let stateObj = [];
				let commodityAllocationIds = [];
				for (var i = 0; i < objs.length; i++) {
					if (state == 2) {
						if (objs[i].checkState != 1) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "选中记录中包含不可审核的数据！"
							});
							return;
						}

						stateObj.push({
							id: objs[i].id,
							state: 2
						});
						commodityAllocationIds.push(objs[i].id);
					}
				}

				this.$Modal.confirm({
					title: "操作警告",
					content: func,
					onOk() {
						request.post('/api/CommodityAllocationList/CheckCommodityAllocationList', stateObj).then(
							function(response) {

								if (response.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: response.errorMsg
									});
									return;
								}
								let tag = '';
								if (state == 1) {

								} else if (state == 2) {
									tag = '审核';
								}

								var log = [];
								for (var i = 0; i < commodityAllocationIds.length; i++) {
									//记录采购单操作
									log.push({
										FlowId: commodityAllocationIds[i],
										Title: '商品调拨单日志',
										OperationContent: tag + '了此商品调拨单',
										Operator: parseInt(localStorage.getItem("userId")),
										State: 1,
										Creator: parseInt(localStorage.getItem("userId"))
									});
								}

								request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
									if (response.data.state == 0) {
										self.$Notice.error({
											title: '错误提示',
											duration: 3,
											desc: '日志记录失败:' + response.data.errorMsg
										});
										return;
									}
								}).catch(function(error) {})
								self.$Notice.success({
									title: '正确提示',
									duration: 3,
									desc: tag + '成功!'
								});
								self.emptyForm();
							}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			initUserToSelect() { //初始化用户下拉框数据源
				let self = this;
				request.get('/api/User/GetUserToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					self.userList = response.data;
				}).catch(function(error) {})
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['CommodityAllocationList.Add', 'CommodityAllocationList.Edit',
						'CommodityAllocationList.Delete',
						'CommodityAllocationList.Audit', 'CommodityAllocationList.BatchAudit',
						'CommodityAllocationList.Print',
						'CommodityAllocationList.Rollback', 'CommodityAllocationList.Export',
						'CommodityAllocationList.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if (tipTimeoutCount != undefined) {
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					} else if (response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)) {
						self.$Modal.warning({
							title: '系统到期提示',
							content: response.errorMsg,
							onOk: () => {
								localStorage.setItem("_tipTimeoutCount", 1);
							}
						});
					}
					if (tipTimeoutCount == undefined || tipTimeoutCount < 1000) {
						localStorage.setItem("_tipTimeoutCount", tipTimeoutCount == undefined ? 1 :
							tipTimeoutCount + 1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'CommodityAllocationList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'CommodityAllocationList.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'CommodityAllocationList.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'CommodityAllocationList.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'CommodityAllocationList.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'CommodityAllocationList.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'CommodityAllocationList.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'CommodityAllocationList.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'CommodityAllocationList.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			getWarehousingName(warehousing) {
				let params = warehousing;
				let result = '';
				if (params.length < 1) {
					return;
				}
				this.depotTree.forEach(item => {
					if (item.value == params[0]) {
						result += item.text;
						item.children.forEach(item2 => {
							if (item2.value == warehousing) {
								result += ',' + item2.text;
							}
						});
					}
				});
				return result;
			},
			packPrintData(data) {
				data.forEach((item, index) => {
					switch (item.checkState) {
						case 1:
							item.checkState = '已创建'
							break;
						case 2:
							item.checkState = '已审核'
							break;
						case 3:
							item.checkState = '已完结'
							break;
					}
					item.businessDate = item.businessDate.replace(' 00:00:00', '');
					item.warehousing = this.getWarehousingName(item.warehousing);
				})
				let selectedReceiptData = {
					name: 'commodityAllocationList',
					title: '商品调拨单',
					attributes: ['baseFieldItem', 'commodityAllocationDetailList'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'warehousing',
							displayName: '入库仓库'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					commodityAllocationDetailList: [{
							name: 'name',
							displayName: '商品名'
						},
						{
							name: 'format',
							displayName: '商品规格'
						},
						// {
						// 	name: 'batchCode',
						// 	displayName: '商品批次'
						// },
						{
							name: 'outboundName',
							displayName: '出库仓库'
						},
						{
							name: 'unit',
							displayName: '计量单位'
						},
						{
							name: 'quantity',
							displayName: '数量'
						}
					]
				}
				localStorage.setItem('_printData', JSON.stringify(selectedReceiptData));
				this.$router.push({
					path: 'printerpage'
				});
			},
			printList() {
				this.packPrintData([this.documentItem]);
			},
			getAllocationList(allocationListId) {
				let self = this;
				request.get('/api/CommodityAllocationList/GetCommodityAllocationList', {
					params: {
						id: allocationListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.initAllocationList(response.data);
				}).catch(function(error) {})
			},
			initAllocationList(data) {
				this.documentItem = data;
				if (this.documentItem.warehousing) {
					let array = [];
					array.push(this.documentItem.warehousing.split(',')[0]);
					array.push(this.documentItem.warehousing);
					this.documentItem.warehousing = array;
				}
			},
			formatBatchCodeSelectData(index,unit) {
				let data = this.documentItem.commodityAllocationDetailList[index];
				let unitData = this.getUnitData(data,unit);
				if (data && unitData) {
					let list = []
					if (data.commodity.commodityInventorys) {
						let array = data.commodity.commodityInventorys.filter(m => m.stock > 0 && m
							.commodityPriceType == data.format && m.depotId == data.outbound);
						array = array.sort((a, b) => new Date(a.sellByDate[1]) - new Date(b.sellByDate[1]));
						for (let i = 0; i < array.length; i++) {
							list.push({
								value: array[i].batchCode,
								text: `${array[i].batchCode}(${formatNum(array[i].stock*unitData.conversionRate)}${unit})`
							})
						}
					}
					return list;
				}
			},
			initDepotData() {
				let self = this;
				request.get('/api/Depot/GetDepotList').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取仓库数据失败：" + response.errorMsg
						});
						return;
					}
					self.depotList = response.data;
				}).catch(function(error) {})
			},
			getTransferDepot() {
				let self = this;
				request.get('api/Depot/GetTransferDepot').then(function(result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取调拨仓库失败:" + response.errorMsg
						});
						return;
					}

					// 转换数据结构，确保 children 始终是数组
					const convertData = (data) => {
						if (!data || !Array.isArray(data)) return [];

						return data.map(item => {
							const newItem = {
								value: item.value || item.id, // 确保有 value 字段
								label: item.label || item.text || item.name, // 确保有 label 字段
							};

							// 处理 children：如果是数组就递归转换，否则设为空数组
							if (item.children && Array.isArray(item.children) && item.children.length >
								0) {
								newItem.children = convertData(item.children);
							} else {
								newItem.children = []; // 确保 children 是空数组而不是 null
							}

							return newItem;
						});
					};

					self.depotTree = convertData(result.data);
				}).catch(err => {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "获取调拨仓库失败"
					});
				})
			},
		},
		watch: {
			'$route.query.allocationListId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getAllocationList(param);
					} else {
						this.emptyForm();
					}
				}
			}
		},
		created: function() {
			this.emptyForm();
			this.initPermission();
			this.initUserToSelect();
			this.initDepotData();
			this.getTransferDepot();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-left: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.baseInfo {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	.baseinfo-table td,
	.baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}


	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.file {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.discount-label {
		display: inline-block;
		text-align: center;
		width: 29%;
	}

	.billStateCls {
		width: 100px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		position: absolute;
		top: 100px;
		left: 200px;
		border: solid 2px red;
		color: red;
		font-weight: 600;
		-webkit-transform: rotate(-30deg);
		transform: rotate(-30deg);
		z-index: 19999;
	}

	/deep/ .ivu-cascader .ivu-input {
		border: none;
	}
</style>